
import React from 'react';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { motion, AnimatePresence } from 'framer-motion';

interface BulletinActionsProps {
  bulletinId: string;
  likeCount: number;
  hasLiked: boolean;
}

const BulletinActions = ({ 
  bulletinId, 
  likeCount,
  hasLiked,
}: BulletinActionsProps) => {
  if (likeCount === 0) {
    return null;
  }
  // Only show engagement if user has liked this post
  if (!hasLiked) return null;

  const displayCount = likeCount ?? 0;

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="flex items-center gap-1 sm:gap-2"
        style={{
          transform: 'translate3d(0, 0, 0)',
        }}
      >
        <Button 
          variant="ghost" 
          size="sm"
          disabled={true}
          className="text-white bg-black/50 hover:text-primary hover:bg-primary/10 h-6 sm:h-7 w-10 sm:w-12 rounded-full cursor-default"
        >
          <Heart className="w-2 h-2 sm:w-3 sm:h-3 mr-0.5 sm:mr-1 fill-current" />
          <span className="min-w-[1ch] text-[10px] sm:text-sm font-semibold">{displayCount}</span>
        </Button>
      </motion.div>
    </AnimatePresence>
  );
};

export default BulletinActions;
